<template>
  <div class="security-notification-container">
    <SecurityNotification
      v-for="notification in notifications"
      :key="notification.id"
      :type="notification.type"
      :title="notification.title"
      :message="notification.message"
      :duration="notification.duration"
      :show-progress="notification.showProgress"
      @dismiss="removeNotification(notification.id)"
    />
  </div>
</template>

<script setup>
import { useSecurityNotifications } from '~/composables/useSecurityNotifications'

const { notifications, removeNotification } = useSecurityNotifications()
</script>

<style scoped>
.security-notification-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 400px;
  pointer-events: none;
}

.security-notification-container > * {
  pointer-events: auto;
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .security-notification-container {
    top: 0.5rem;
    right: 0.5rem;
    left: 0.5rem;
    max-width: none;
  }
}
</style>
